globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modules = appCustomerSpace.Modules || {};

appCustomerSpace.Modules.PasswordComplexityMessages = (function() {

  function PasswordComplexityMessages($form) {
    this.$html                    = $form;
    this.$passwordInput           = this.$html.find("input[type='password']#contact_password");
    this.$passwordConfInput       = this.$html.find("input[type='password']#contact_password_confirmation");
    this.$passwordConfMsgIcon     = this.$html.find(".password-confirmation-message i");
    this.$messages                = this.$html.find(".password-complexity-messages");
    this.$passwordConfMsg         = this.$html.find(".password-confirmation-message");
    this.nbOfMessages             = this.$messages.find("p").length;
    this.$progressBar             = this.$html.find(".progress-bar");
    this.$submitBtn               = this.$html.find("button[type='submit']");
    this.ajaxUrl                  = this.$messages.data("ajax-url");

    if(this.$passwordInput.length && this.ajaxUrl.length) {
      this.init();
    }
  }

  PasswordComplexityMessages.init = function($html) {
    $html.find('form').each(function(){
      new PasswordComplexityMessages($(this));
    })
  }

  PasswordComplexityMessages.prototype = {
    init: function() {
      this.disableSubmit();
      this.disablePasswordConfirmation();
      this.events();
    },
    enableSubmit: function() {
      this.$submitBtn.removeAttr("disabled");
    },
    disableSubmit: function() {
      this.$submitBtn.attr("disabled", "disabled");
    },
    enablePasswordConfirmation: function() {
      this.$passwordConfInput.removeAttr("disabled", "disabled");
      this.$passwordConfMsg.show();
    },
    disablePasswordConfirmation: function() {
      this.$passwordConfInput.attr("disabled", "disabled");
      this.$passwordConfMsg.hide();
    },
    events: function() {
      var controller = this;

      controller.$passwordInput.on("keyup", function() {
        setTimeout(controller.getData(), 50);
        setTimeout(controller.checkPasswordConfirmation(), 50);
        controller.$messages.show();
      });

      controller.$passwordConfInput.on("keyup", function() {
        setTimeout(controller.checkPasswordConfirmation(), 50);
      });
    },
    getData: function() {
      var controller = this;

      $.ajax({
        url: controller.ajaxUrl,
        data: { password: controller.$passwordInput.val() },
        success: function(data) {
          if(data.response == 1) {
            controller.setScoreProgress(data.score, data.color);
            controller.setMessages(data.messages);
          } else {
            controller.setScoreProgress(0);
            controller.clearMessages();
          }
        }
      })
    },
    setScoreProgress: function(score, color) {
      this.$progressBar.css("width", `${parseInt(score * 10)}%`);
      if(color) {
        this.$progressBar.css("background-color", `${color}`);
      }
    },
    setMessages: function(messages) {
      var controller = this;
      var validInputsSize = 0;

      $.each(messages, function(k, v) {
        if(v.validity) { validInputsSize += 1; }
        controller.setMessageValidity(k, v.validity);
      })

      if(validInputsSize == controller.nbOfMessages) {
        controller.enablePasswordConfirmation();
      } else {
        controller.disablePasswordConfirmation();
        controller.disableSubmit();
      }
    },
    setMessageValidity(key, validity) {
      var controller = this;

      if(validity) {
        controller.$messages.find(`#${key} i`).removeClass("fa-times text-danger")
        controller.$messages.find(`#${key} i`).addClass("fa-check text-success")
      } else {
        controller.$messages.find(`#${key} i`).removeClass("fa-check text-success")
        controller.$messages.find(`#${key} i`).addClass("fa-times text-danger")
      }
    },
    clearMessages: function() {
      this.$messages.find("i").removeClass("fa-check text-success");
      this.$messages.find("i").addClass("fa-times text-danger");
    },
    checkPasswordConfirmation: function() {
      var controller = this;

      if(controller.$passwordInput.val() == controller.$passwordConfInput.val()) {
        controller.$passwordConfMsgIcon.removeClass("fa-times text-danger");
        controller.$passwordConfMsgIcon.addClass("fa-check text-success");
        controller.enableSubmit();
      } else {
        controller.$passwordConfMsgIcon.removeClass("fa-check text-success");
        controller.$passwordConfMsgIcon.addClass("fa-times text-danger");
        controller.disableSubmit();
      }
    },
  }

  return PasswordComplexityMessages;
})();
